module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -2.23a461fb.png";